import React from "react";
import { Box, Button } from "@mui/material";
import QuickPeriodButtons from "./QuickPeriodButtons";
import { colors, sections } from "../utils/datosTheme";

export default function DatosNav({ active, onChange, showQuickFilters, preset, onPresetChange }) {
  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 30,
        display: "flex",
        alignItems: "stretch",
        justifyContent: "space-between",
        gap: { xs: 0, md: 2 },
        flexWrap: { xs: "wrap", lg: "nowrap" },
        borderBottom: `1px solid ${colors.line}`,
        backgroundColor: "rgba(255,255,255,0.94)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        boxShadow: showQuickFilters ? "0 8px 22px rgba(15, 42, 89, 0.08)" : "none",
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "stretch",
          flex: "0 0 auto",
          width: "fit-content",
          maxWidth: "100%",
          flexWrap: "wrap",
        }}
      >
        {sections.map((section) => {
          const isActive = active === section;
          return (
            <Button
              key={section}
              onClick={() => onChange(section)}
              disableRipple
              sx={{
                flex: "0 0 auto",
                width: { xs: 112, sm: 150 },
                minWidth: { xs: 112, sm: 150 },
                maxWidth: { xs: 112, sm: 150 },
                height: 50,
                px: { xs: 1.25, sm: 2 },
                borderRadius: 0,
                color: isActive ? colors.blue : "#555963",
                fontWeight: 900,
                fontSize: 13,
                letterSpacing: 0,
                textTransform: "none",
                position: "relative",
                whiteSpace: "nowrap",
                "&:hover": {
                  backgroundColor: "rgba(0,89,246,0.05)",
                  color: colors.blue,
                },
                "&::after": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  right: 0,
                  bottom: -1,
                  height: 2,
                  backgroundColor: isActive ? colors.blue : "transparent",
                },
              }}
            >
              {section}
            </Button>
          );
        })}
      </Box>

      {showQuickFilters && (
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            justifyContent: "flex-end",
            flex: "0 0 auto",
            pr: { md: 2, lg: 3 },
            py: 0.75,
          }}
        >
          <QuickPeriodButtons preset={preset} onPresetChange={onPresetChange} compact />
        </Box>
      )}
    </Box>
  );
}
